
export const SupplierOptions = (t) => [
  { id: "1", value: "Sterimax", label: t("other.lblInboundSupplierSterimax")},
  { id: "2", value: "BT", label: t("other.lblInboundSupplierBT")},
  { id: "3", value: "Lidl", label: t("other.lblInboundSupplierLidl")},
  { id: "4", value: "Pets at home", label: t("other.lblInboundSupplierPetsAtHome")},
  { id: "5", value: "TVS", label: t("other.lblInboundSupplierTVS")},
  { id: "6", value: "VOW", label: t("other.lblInboundSupplierVOW")},
  { id: "7", value: "FFC", label: t("other.lblInboundSupplierFFC")},
  { id: "8", value: "Wincanton", label: t("other.lblInboundSupplierWincanton")},
  { id: "9", value: "Wingston", label: t("other.lblInboundSupplierWingston")},
  { id: "10", value: "ST Gobain", label: t("other.lblInboundSupplierSTGobain")},
  { id: "11", value: "Sandersons", label: t("other.lblInboundSupplierSandersons")},
  { id: "12", value: "Digital", label: t("other.lblInboundSupplierDigital")},
  { id: "13", value: "Westpack", label: t("other.lblInboundSupplierWestpack")},
  { id: "14", value: "Pepsico", label: t("other.lblInboundSupplierPepsico")},
];

export const LoadingBayOptions = (t) => [
  { id: "1", value: "1", label: "1" },
  { id: "2", value: "2", label: "2" },
  { id: "3", value: "3", label: "3" },
  { id: "4", value: "4", label: "4" },
  { id: "5", value: "5", label: "5" },
  { id: "6", value: "6", label: "6" },
  { id: "7", value: "7", label: "7" },
  { id: "8", value: "8", label: "8" },
  { id: "9", value: "9", label: "9" },
  { id: "10", value: "10", label: "10" },
  { id: "11", value: "11", label: "11" },
  { id: "12", value: "12", label: "12" },
  { id: "13", value: "13", label: "13" },
  { id: "14", value: "14", label: "14" },
  { id: "15", value: "15", label: "15" },
  { id: "16", value: "16", label: "16" },
  { id: "17", value: "17", label: "17" },
  { id: "18", value: "18", label: "18" },
  { id: "19", value: "19", label: "19" },
  { id: "20", value: "20", label: "20" },
  { id: "21", value: "21", label: "21" },
  { id: "22", value: "22", label: "22" },
  { id: "23", value: "23", label: "23" },
  { id: "24", value: "24", label: "24" },
  { id: "25", value: "25", label: "25" },
  { id: "26", value: "26", label: "26" },
  { id: "27", value: "27", label: "27" },
  { id: "28", value: "28", label: "28" },
  { id: "29", value: "29", label: "29" },
  { id: "30", value: "30", label: "30" },
  { id: "31", value: "31", label: "31" },
  { id: "32", value: "32", label: "32" },
  { id: "33", value: "33", label: "33" },
  { id: "34", value: "34", label: "34" },
  { id: "35", value: "35", label: "35" },
  { id: "36", value: "36", label: "36" },
  { id: "37", value: "37", label: "37" },
  { id: "38", value: "38", label: "38" },
  { id: "39", value: "39", label: "39" },
  { id: "40", value: "40", label: "40" },
  { id: "41", value: "41", label: "41" },
  { id: "42", value: "42", label: "42" },
  { id: "43", value: "43", label: "43" },
  { id: "44", value: "44", label: "44" },
  { id: "45", value: "45", label: "45" },
  { id: "46", value: "46", label: "46" },
  { id: "47", value: "47", label: "47" },
  { id: "48", value: "48", label: "48" },
  { id: "49", value: "49", label: "49" },
  { id: "50", value: "50", label: "50" },
  { id: "A", value: "A", label: "A" },
  { id: "B", value: "B", label: "B" },
  { id: "C", value: "C", label: "C" },
  { id: "D", value: "D", label: "D" },
  { id: "E", value: "E", label: "E" },
  { id: "F", value: "F", label: "F" },
  { id: "G", value: "G", label: "G" },
];

export const BuildingOptions = [
  {id: "1", value: "MPN2", label: "MPN2"},
  {id: "2", value: "MPN3", label: "MPN3"},
  {id: "3", value: "K1", label: "K1"},
  {id: "4", value: "K2", label: "K2"},
  {id: "5", value: "R3", label: "R3"},
]